export function useQuery(param: string): string | null {
  const queryParams = new URLSearchParams(window.location.search);
  const valor = queryParams.get(param);

  return valor;
}
